import { Form as AntdForm } from 'antd'
import type { ValidatorRule } from 'rc-field-form/lib/interface'
import type { ComponentProps } from 'react'

import { type ValidationRulesKeys, useFormValidationRules } from '@/hooks/useFormValidationRules'

interface FormListProps extends Omit<ComponentProps<typeof AntdForm.List>, 'rules'> {
  validation?: ValidationRulesKeys
}

export function FormList({
  children,
  initialValue,
  name,
  validation = 'noValidation',
}: FormListProps) {
  const rules = useFormValidationRules()

  return (
    <AntdForm.List
      initialValue={initialValue}
      name={name}
      rules={rules[validation] as ValidatorRule[]}
    >
      {children}
    </AntdForm.List>
  )
}
